/*! Ardor Printing DTF t-shirt 3D preview v1.0 (window.ArdorDtf3D).
 * Needs global THREE (r147) and THREE.OrbitControls loaded first. No other files and no network loads: the shirt is
 * built from math and every texture is drawn with canvas.
 * Units are inches, y up, the shirt's front faces +z, the wearer's left is +x (your right when you face the shirt).
 * Print areas: "front", "back", "sleeveL" (wearer's left sleeve), "sleeveR". setPrint() places the art at TRUE size:
 *   widthIn x heightIn, xIn = the art's CENTRE left/right of the area's centre line (+ = to your right as you look at
 *   that area), yIn = from the anchor DOWN to the art's TOP edge. Anchors: front/back = the collar seam at the centre,
 *   sleeves = the shoulder seam (where the sleeve meets the shoulder), measured down the outside of the sleeve. */
(function (root) {
  "use strict";

  var PI = Math.PI, FOV = 28, EL_MAX = 1.25, EL_MIN = 0.0, DEFAULT_BG = "#f4f6f5", FILL_HOME = 0.9, FILL_NEAR = 0.97, FILL_FAR = 0.42;
  // camera views: [azimuth (0 = front, +PI/2 = the wearer's left side), elevation]. "left" shows the LEFT SLEEVE.
  var VIEWS = { home: [0.52, 0.12], front: [0, 0.04], back: [PI, 0.04], left: [1.3, 0.3], right: [-1.3, 0.3] };
  var VIEW_ALIAS = { sleevel: "left", sleever: "right", leftsleeve: "left", rightsleeve: "right", side: "left", three: "home", "3/4": "home" };
  var COLORS = {
    "white": "#f6f6f4", "black": "#1d1d1f", "heather gray": "#a7a8aa", "charcoal": "#45474c", "navy": "#1f2a44",
    "royal": "#2b4fa6", "red": "#c3202f", "maroon": "#5b1f2b", "forest": "#1e4a33", "kelly green": "#1a8a4b",
    "gold": "#f1b434", "pink": "#f2b3c6"
  };
  // standard placements (true size, inches); x/y as in setPrint
  var PRESETS = {
    adult: {
      leftChest: { area: "front", widthIn: 3.5, xIn: 4, yIn: 3 }, fullFront: { area: "front", widthIn: 11, xIn: 0, yIn: 3 },
      fullBack: { area: "back", widthIn: 12, xIn: 0, yIn: 3.5 }, sleeveL: { area: "sleeveL", widthIn: 3, xIn: 0, yIn: 2.5 },
      sleeveR: { area: "sleeveR", widthIn: 3, xIn: 0, yIn: 2.5 }
    },
    youth: {
      leftChest: { area: "front", widthIn: 3, xIn: 3.2, yIn: 2.5 }, fullFront: { area: "front", widthIn: 9, xIn: 0, yIn: 2.5 },
      fullBack: { area: "back", widthIn: 10, xIn: 0, yIn: 3 }, sleeveL: { area: "sleeveL", widthIn: 2.5, xIn: 0, yIn: 2 },
      sleeveR: { area: "sleeveR", widthIn: 2.5, xIn: 0, yIn: 2 }
    }
  };
  // garment sizes. The form is drawn in adult units and scaled; neckline numbers are in adult units (before scaling).
  var SIZES = {
    adult: { sx: 1, sy: 1, sz: 1, nw: 3.6, dropF: 3.2, dropB: 0.85, rib: 0.85 },
    youth: { sx: 0.83, sy: 0.79, sz: 0.84, nw: 3.8, dropF: 3.3, dropB: 0.9, rib: 0.75 }
  };

  /* ================= the invisible form (adult, inches; y = 0 is the hem) ================= */
  // torso: stacked superellipse slices (|x/a|^3 + |z/b|^3 = 1, b = front or back depth), half width a(y), centre c(y)
  var CTL = {
    a: [[-4, 9.1], [0, 9.05], [3, 8.95], [8, 8.8], [14, 8.8], [19, 8.85], [25.4, 8.85], [26.3, 8.8], [26.9, 8.7], [27.2, 8.6],
      [27.6, 7.49], [28, 6.38], [28.5, 4.99], [29, 3.6], [29.4, 2.4], [29.7, 1.2], [29.85, 0.5]],
    f: [[-4, 4.1], [0, 4.1], [6, 4.0], [12, 4.05], [17, 4.3], [21, 4.45], [24, 4.2], [26, 3.65], [27.5, 3.1], [28.6, 2.6], [29.4, 2.0], [29.85, 1.2]],
    b: [[-4, 3.85], [0, 3.85], [8, 3.6], [14, 3.7], [19, 4.0], [23, 4.1], [25.5, 3.8], [27.5, 3.25], [28.6, 2.8], [29.4, 2.2], [29.85, 1.3]],
    c: [[-4, 0.15], [0, 0.15], [12, 0], [20, 0], [26, -0.2], [29, -0.4], [29.85, -0.45]]
  };
  var T0 = -4, TS = 0.02, TN = 1701, TOPY = 29.85, TAB = null;
  // arms: capsules down and out at 50 degrees; MID is the centre of the (adult) sleeve hem, a = distance along the arm from it
  var SPX = 8.6, ARM_AL = 50 * PI / 180, ADX = Math.sin(ARM_AL), ADY = -Math.cos(ARM_AL), MID = [13.32, 19.64, -0.25],
    AR = 2.72, A0 = -8.0, A1 = 1.8, A_HEM = 0;

  function mono(pts) { // monotone cubic (Fritsch-Carlson) -> f(x) = [y, dy/dx]
    var n = pts.length, X = [], Y = [], d = [], m = [], i, a, b, s, t;
    for (i = 0; i < n; i++) { X.push(pts[i][0]); Y.push(pts[i][1]); }
    for (i = 0; i < n - 1; i++) d.push((Y[i + 1] - Y[i]) / (X[i + 1] - X[i]));
    m[0] = d[0]; m[n - 1] = d[n - 2];
    for (i = 1; i < n - 1; i++) m[i] = d[i - 1] * d[i] <= 0 ? 0 : (d[i - 1] + d[i]) / 2;
    for (i = 0; i < n - 1; i++) {
      if (d[i] === 0) { m[i] = m[i + 1] = 0; continue; }
      a = m[i] / d[i]; b = m[i + 1] / d[i]; s = a * a + b * b;
      if (s > 9) { t = 3 / Math.sqrt(s); m[i] = t * a * d[i]; m[i + 1] = t * b * d[i]; }
    }
    return function (x) {
      if (x <= X[0]) return [Y[0], 0];
      if (x >= X[n - 1]) return [Y[n - 1], 0];
      var k = 0; while (x > X[k + 1]) k++;
      var h = X[k + 1] - X[k], u = (x - X[k]) / h, u2 = u * u, u3 = u2 * u;
      return [(2 * u3 - 3 * u2 + 1) * Y[k] + (u3 - 2 * u2 + u) * h * m[k] + (3 * u2 - 2 * u3) * Y[k + 1] + (u3 - u2) * h * m[k + 1],
        ((6 * u2 - 6 * u) * Y[k] + (3 * u2 - 4 * u + 1) * h * m[k] + (6 * u - 6 * u2) * Y[k + 1] + (3 * u2 - 2 * u) * h * m[k + 1]) / h];
    };
  }
  function tables() {
    if (TAB) return TAB;
    var T = {}, k, i, f, r;
    for (k in CTL) if (CTL.hasOwnProperty(k)) {
      f = mono(CTL[k]); T[k] = new Float64Array(TN); T[k + "d"] = new Float64Array(TN);
      for (i = 0; i < TN; i++) { r = f(T0 + i * TS); T[k][i] = r[0]; T[k + "d"][i] = r[1]; }
    }
    TAB = T;
    return T;
  }
  function hyp(a, b, c) { return Math.sqrt(a * a + b * b + (c ? c * c : 0)); }
  function smin(a, b, k) { var h = Math.max(k - Math.abs(a - b), 0) / k; return Math.min(a, b) - h * h * k * 0.25; }
  function smooth(e0, e1, v) { var t = (v - e0) / (e1 - e0); t = t < 0 ? 0 : t > 1 ? 1 : t; return t * t * (3 - 2 * t); }
  function torsoD(x, y, z) {
    var T = TAB, f = (y - T0) / TS, i, r;
    if (f < 0) f = 0; else if (f > TN - 1.001) f = TN - 1.001;
    i = f | 0; r = f - i;
    var a = T.a[i] + (T.a[i + 1] - T.a[i]) * r, ad = T.ad[i] + (T.ad[i + 1] - T.ad[i]) * r,
      c = T.c[i] + (T.c[i + 1] - T.c[i]) * r, cd = T.cd[i] + (T.cd[i + 1] - T.cd[i]) * r, zz = z - c, fr = zz >= 0,
      B = fr ? T.f : T.b, BD = fr ? T.fd : T.bd, b = B[i] + (B[i + 1] - B[i]) * r, bd = BD[i] + (BD[i + 1] - BD[i]) * r,
      ux = Math.abs(x) / a, uz = Math.abs(zz) / b, ux2 = ux * ux, uz2 = uz * uz, sg = fr ? 1 : -1,
      fv = ux2 * ux + uz2 * uz - 1, gx = 3 * ux2 / a, gz = 3 * uz2 / b, gy = -3 * ux2 * ux * ad / a - 3 * uz2 * (sg * cd + uz * bd) / b,
      g = Math.sqrt(gx * gx + gy * gy + gz * gz), d = g > 1e-6 ? fv / g : -b;
    if (d < -b) d = -b;
    if (y > TOPY) d = Math.max(d, y - TOPY);
    return d;
  }
  function armD(x, y, z) {
    var px = Math.abs(x) - MID[0], py = y - MID[1], pz = z - MID[2], a = px * ADX + py * ADY;
    a = a < A0 ? A0 : a > A1 ? A1 : a;
    var qx = px - a * ADX, qy = py - a * ADY;
    return Math.sqrt(qx * qx + qy * qy + pz * pz) - AR;
  }
  function neckD(x, y, z) {
    var u = x / 2.3, v = (z + 0.55) / 2.45;
    return Math.max((Math.sqrt(u * u + v * v) - 1) * 2.35, 24 - y, y - 34);
  }
  function F(x, y, z) { return smin(smin(torsoD(x, y, z), armD(x, y, z), 1.2), neckD(x, y, z), 1.0); }
  function axA(x, y) { return (x - MID[0]) * ADX + (y - MID[1]) * ADY; }

  // ray from the front (dir 1: the largest z inside) or the back (dir -1); NaN when the ray misses
  function hz(x, y, dir, hint) {
    var z = hint === hint && hint !== undefined ? hint + dir * 0.8 : dir * 9, f = F(x, y, z), n = 0, z2, f2, st, k, zm;
    while (f <= 0 && n++ < 30) { z += dir * 0.8; f = F(x, y, z); }
    for (n = 0; n < 500; n++) {
      st = f * 0.6; st = st < 0.04 ? 0.04 : st > 0.6 ? 0.6 : st;
      z2 = z - dir * st; f2 = F(x, y, z2);
      if (f2 <= 0) {
        for (k = 0; k < 16; k++) { zm = (z + z2) / 2; if (F(x, y, zm) <= 0) z2 = zm; else z = zm; }
        return (z + z2) / 2;
      }
      z = z2; f = f2;
      if (dir * z < -9) return NaN;
    }
    return NaN;
  }
  function inside(x, y) { var z = hz(x, y, 1); return z === z; }
  function bis(fin, a, b) { for (var k = 0; k < 16; k++) { var m = (a + b) / 2; if (fin(m)) a = m; else b = m; } return (a + b) / 2; }
  function zMid(x, y) { // the silhouette depth: where F is smallest along z
    var a = -6, b = 6, gr = 0.6180339887, c = b - gr * (b - a), d = a + gr * (b - a), fc = F(x, y, c), fd = F(x, y, d), k;
    for (k = 0; k < 44; k++) {
      if (fc < fd) { b = d; d = c; fd = fc; c = b - gr * (b - a); fc = F(x, y, c); }
      else { a = c; c = d; fc = fd; d = a + gr * (b - a); fd = F(x, y, d); }
    }
    return (a + b) / 2;
  }
  function gradN(x, y, z) {
    var e = 0.01, gx = F(x + e, y, z) - F(x - e, y, z), gy = F(x, y + e, z) - F(x, y - e, z), gz = F(x, y, z + e) - F(x, y, z - e),
      l = Math.sqrt(gx * gx + gy * gy + gz * gz) || 1;
    return [gx / l, gy / l, gz / l];
  }
  function fold(x, y, px, py, dx, dy, len, sig, amp) { // a soft drag fold running from (px, py) along (dx, dy)
    var rx = x - px, ry = y - py, al = rx * dx + ry * dy, ac = ry * dx - rx * dy, e;
    if (al <= 0 || al >= len) return 0;
    e = 1 - al / len;
    return amp * e * e * (1 - Math.exp(-al * 1.6)) * Math.exp(-ac * ac / (2 * sig * sig));
  }

  /* ================= the garment, built once per size (plain arrays, shared by every viewer) ================= */
  var GCACHE = {};
  function shirt(size) {
    if (GCACHE[size]) return GCACHE[size];
    tables();
    var Z = SIZES[size], sx = Z.sx, sy = Z.sy, sz = Z.sz, nw = Z.nw, NC = 30, NU = 16, k, i, j, r, c;
    function topAt(x) { var y = x > 2.6 ? 30.8 : 33.5; while (y > 0 && !inside(x, y)) y -= 0.25; return bis(function (t) { return inside(x, t); }, y, y + 0.25); }
    function exitX(y) { var x = inside(6, y) ? 6 : 0; while (x < 22 && inside(x + 0.3, y)) x += 0.3; return bis(function (t) { return inside(t, y); }, x, x + 0.3); }
    function reentryX(y, x0) { var x = x0; while (x < 22 && !inside(x, y)) x += 0.2; return x >= 22 ? NaN : bis(function (t) { return inside(t, y); }, x, x - 0.2); }
    function outerX(y, x0) { var x = x0 || 22; while (x < 22 && inside(x, y)) x += 1; while (x > 0 && !inside(x, y)) x -= 0.2; return bis(function (t) { return inside(t, y); }, x, x + 0.2); }
    function gapAt(y) { return reentryX(y, exitX(y) + 0.02); }
    // key points: high shoulder point, shoulder point, underarm (top of the gap between body and sleeve)
    var HPS = [nw, topAt(nw)], yH = HPS[1], SP = [SPX, topAt(SPX)], yg = SP[1] - 2, v;
    while (yg > 5) { v = gapAt(yg); if (v === v) break; yg -= 0.4; }
    var yUA = bis(function (t) { var q = gapAt(t); return q === q; }, yg, yg + 0.4) - 0.002, x1 = exitX(yUA), x2 = gapAt(yUA),
      UA = [(x1 + (x2 === x2 ? x2 : x1)) / 2, yUA], yNF = yH - Z.dropF, yNB = yH - Z.dropB;
    // the armhole seam (front view): from the underarm up to the shoulder point, bowing in a little
    function armAt(t) { return [UA[0] + (SP[0] - UA[0]) * t - 0.45 * Math.sin(PI * t), UA[1] + (SP[1] - UA[1]) * t]; }
    var tn = (yNF - UA[1]) / (SP[1] - UA[1]), n1 = 11, n2 = 14, ARM = [];
    for (k = 0; k <= n1; k++) ARM.push(armAt(tn * (1 - Math.cos(PI * k / n1)) / 2));
    for (k = 1; k <= n2; k++) ARM.push(armAt(tn + (1 - tn) * (1 - Math.cos(PI * k / n2)) / 2));
    var NA = ARM.length - 1;
    function armDist(x, y) { // front-view distance to the armhole seam
      var best = 1e9, q, a, b, dx, dy, t, ex, ey;
      for (q = 1; q <= NA; q++) {
        a = ARM[q - 1]; b = ARM[q]; dx = b[0] - a[0]; dy = b[1] - a[1];
        t = ((x - a[0]) * dx + (y - a[1]) * dy) / (dx * dx + dy * dy); t = t < 0 ? 0 : t > 1 ? 1 : t;
        ex = x - a[0] - t * dx; ey = y - a[1] - t * dy; t = ex * ex + ey * ey;
        if (t < best) best = t;
      }
      return Math.sqrt(best);
    }
    // drape: soft folds from the underarms, a little ripple at the hem, folds on the sleeves (adult units, normal offset)
    function wrinkle(x, y, side) {
      var w = 0, ux = UA[0], uy = UA[1];
      if (side > 0) { // drag folds from the underarm toward the chest, soft ripples low on the body
        w += fold(x, y, ux - 0.3, uy + 0.4, -0.88, -0.47, 7, 0.6, 0.2) - fold(x, y, ux - 0.4, uy - 0.6, -0.86, -0.51, 6, 0.55, 0.1);
        w += fold(x, y, ux - 0.2, uy - 1.4, -0.74, -0.67, 5.5, 0.5, 0.12);
        w += 0.09 * smooth(9, 0, y) * Math.sin(x * 0.8 + 0.5 + y * 0.25) * smooth(1, 4, x) + 0.11 * smooth(10, 2, y) * smooth(5.5, 7.5, x) * Math.sin(x * 2.1 + y * 0.35);
      } else {
        w += fold(x, y, ux - 0.3, uy + 0.6, -0.9, -0.42, 7, 0.65, 0.17) - fold(x, y, ux - 0.4, uy - 0.6, -0.85, -0.52, 6, 0.55, 0.08);
        w += 0.1 * smooth(10, 0, y) * Math.sin(x * 0.7 + 1.3 - y * 0.25) * smooth(1, 4, x) + 0.1 * smooth(10, 2, y) * smooth(5.5, 7.5, x) * Math.sin(x * 1.9 - y * 0.3 + 0.8);
        w += 0.04 * smooth(19, 22, y) * smooth(28, 24, y) * Math.sin(x * 0.9);
      }
      // the sleeve: folds from the underarm up toward the shoulder
      w += fold(x, y, ux + 0.3, uy + 0.3, 0.42, 0.91, 4.6, 0.5, 0.16) + fold(x, y, ux + 1.5, uy - 0.3, 0.55, 0.83, 4, 0.45, 0.11) - fold(x, y, ux + 0.9, uy, 0.48, 0.88, 4, 0.4, 0.06);
      return w;
    }
    // a surface point: ray hit (or the silhouette depth), then the drape along the form's normal
    function point(x, y, dir, sil, hint) {
      var z = sil ? zMid(x, y) : hz(x, y, dir, hint);
      if (z !== z) z = zMid(x, y);
      var n = gradN(x, y, z), fade = smooth(0.12, 0.55, Math.abs(n[2])) * smooth(0, 0.9, armDist(x, y)), w = wrinkle(x, y, dir) * fade;
      return { p: [x + n[0] * w, y + n[1] * w, z + n[2] * w], n: n, z: z };
    }

    // ---- 2D layout (front view) of each grid; then front and back surfaces from it ----
    function grid(nr, nc) { return { nr: nr, nc: nc, x: new Float64Array(nr * nc), y: new Float64Array(nr * nc), sil: new Uint8Array(nr * nc), seamA: new Uint8Array(nr * nc), side: new Uint8Array(nr * nc) }; }
    function cumN(P) { var o = [0], L = 0, q; for (q = 1; q < P.length; q++) { L += hyp(P[q][0] - P[q - 1][0], P[q][1] - P[q - 1][1]); o.push(L); } for (q = 0; q < o.length; q++) o[q] = L ? o[q] / L : 0; return o; }
    function coons(Lf, Rt, Bt, Tp) { // Lf/Rt: K+1 points (v), Bt/Tp: N+1 points (u); arc-length weights
      var K = Lf.length - 1, N = Bt.length - 1, uB = cumN(Bt), uT = cumN(Tp), vL = cumN(Lf), vR = cumN(Rt), out = [], kk, ii, u, w, e, P = [];
      for (kk = 0; kk <= K; kk++) {
        out = [];
        for (ii = 0; ii <= N; ii++) {
          w = (vL[kk] + vR[kk]) / 2; u = uB[ii] + (uT[ii] - uB[ii]) * w;
          w = vL[kk] + (vR[kk] - vL[kk]) * u;
          e = [0, 1].map(function (d) {
            return (1 - u) * Lf[kk][d] + u * Rt[kk][d] + (1 - w) * Bt[ii][d] + w * Tp[ii][d] -
              ((1 - u) * (1 - w) * Bt[0][d] + u * (1 - w) * Bt[N][d] + (1 - u) * w * Tp[0][d] + u * w * Tp[N][d]);
          });
          out.push(e);
        }
        P.push(out);
      }
      return P;
    }
    var U = []; for (i = 0; i <= NC; i++) U.push(Math.sin(PI / 2 * i / NC));
    var nS = 40, rowsF = [], rowsB = [];
    // lower rows: [y, row end x, end is silhouette, end kind (1 side seam, 2 armhole)]
    for (j = 0; j < nS; j++) { var yy = UA[1] * Math.sin(PI / 2 * j / nS); var row = [yy, exitX(yy), 1, 1]; rowsF.push(row); rowsB.push(row); }
    for (k = 0; k <= NA; k++) {
      var rw = [ARM[k][1], ARM[k][0], k === 0 || k === NA ? 1 : 0, 2];
      if (k <= n1) rowsF.push(rw);
      rowsB.push(rw);
    }
    var shoulder = []; // shoulder line (silhouette), HPS -> SP
    for (i = 0; i <= NC; i++) { var xs = nw + (SPX - nw) * U[i]; shoulder.push([xs, i === 0 ? HPS[1] : i === NC ? SP[1] : topAt(xs)]); }
    shoulder[0] = HPS.slice(); shoulder[NC] = SP.slice();
    function lowerInto(G, rows) {
      for (r = 0; r < rows.length; r++) for (c = 0; c <= NC; c++) {
        var q = r * (NC + 1) + c;
        G.x[q] = rows[r][1] * U[c]; G.y[q] = rows[r][0];
        if (c === NC) { G.sil[q] = rows[r][2]; if (rows[r][3] === 2) G.seamA[q] = 1; else G.side[q] = 1; }
      }
    }
    // front: lower rows up to the front neckline row, then the yoke (neckline / shoulder / armhole)
    var K1 = n2, GF = grid(rowsF.length + K1, NC + 1);
    lowerInto(GF, rowsF);
    var Lf = [], Rt = [], Bt = [], Tp = shoulder, ph, P;
    for (k = 0; k <= K1; k++) { ph = PI / 2 * (1 - Math.cos(PI * k / K1)) / 2; Lf.push([nw * Math.sin(ph), yH - Z.dropF * Math.cos(ph)]); Rt.push(ARM[n1 + k]); }
    Lf[0] = [0, yNF]; Lf[K1] = HPS.slice();
    for (i = 0; i <= NC; i++) Bt.push([ARM[n1][0] * U[i], yNF]);
    P = coons(Lf, Rt, Bt, Tp);
    for (k = 1; k <= K1; k++) for (i = 0; i <= NC; i++) {
      var q1 = (rowsF.length - 1 + k) * (NC + 1) + i;
      GF.x[q1] = P[k][i][0]; GF.y[q1] = P[k][i][1];
      if (k === K1) { GF.sil[q1] = 1; GF.seamA[q1] = 1; }
      if (i === NC) GF.seamA[q1] = 1;
    }
    // back: lower rows up to the shoulder point, then the yoke up to the (higher) back neckline
    var GB = grid(rowsB.length + NC, NC + 1);
    lowerInto(GB, rowsB);
    Lf = []; Rt = []; Bt = []; Tp = [];
    for (k = 0; k <= NC; k++) { Lf.push([0, SP[1] + (yNB - SP[1]) * k / NC]); Rt.push(shoulder[NC - k]); }
    for (i = 0; i <= NC; i++) { Bt.push([SP[0] * U[i], SP[1]]); ph = PI / 2 * U[i]; Tp.push([nw * Math.sin(ph), yH - Z.dropB * Math.cos(ph)]); }
    Tp[0] = [0, yNB]; Tp[NC] = HPS.slice();
    P = coons(Lf, Rt, Bt, Tp);
    for (k = 1; k <= NC; k++) for (i = 0; i <= NC; i++) {
      var q2 = (rowsB.length - 1 + k) * (NC + 1) + i;
      GB.x[q2] = P[k][i][0]; GB.y[q2] = P[k][i][1];
      if (i === NC) { GB.sil[q2] = 1; GB.seamA[q2] = 1; }
    }
    // sleeve (+x arm = the wearer's left): armhole -> hem, between the arm's bottom and top silhouettes
    var topPL = [SP.slice()], botPL = [UA.slice()], yq, xo, xa, xb;
    for (yq = SP[1] - 0.2; yq > SP[1] - 14; yq -= 0.2) { xo = outerX(yq, topPL[topPL.length - 1][0] + 0.5); topPL.push([xo, yq]); if (axA(xo, yq) > A_HEM + 0.5) break; }
    for (yq = UA[1] - 0.08; yq > UA[1] - 10; yq -= 0.12) {
      xa = exitX(yq); xb = reentryX(yq, xa + 0.02);
      if (xb !== xb) break;
      botPL.push([xb, yq]); if (axA(xb, yq) > A_HEM + 0.5) break;
    }
    function alongA(pl, a) {
      for (var q = 1; q < pl.length; q++) {
        var a0 = axA(pl[q - 1][0], pl[q - 1][1]), a1 = axA(pl[q][0], pl[q][1]);
        if (a <= a1 || q === pl.length - 1) { var t = (a - a0) / ((a1 - a0) || 1); t = t < 0 ? 0 : t > 1 ? 1 : t; return [pl[q - 1][0] + (pl[q][0] - pl[q - 1][0]) * t, pl[q - 1][1] + (pl[q][1] - pl[q - 1][1]) * t]; }
      }
      return pl[pl.length - 1].slice();
    }
    var HT = alongA(topPL, A_HEM), HB = alongA(botPL, A_HEM), aS = axA(SP[0], SP[1]), aU = axA(UA[0], UA[1]);
    Lf = ARM; Rt = []; Bt = []; Tp = [];
    for (k = 0; k <= NA; k++) { var hk = (1 - Math.cos(PI * k / NA)) / 2; Rt.push([HB[0] + (HT[0] - HB[0]) * hk, HB[1] + (HT[1] - HB[1]) * hk]); }
    for (i = 0; i <= NU; i++) { Bt.push(alongA(botPL, aU + (A_HEM - aU) * i / NU)); Tp.push(alongA(topPL, aS + (A_HEM - aS) * i / NU)); }
    Bt[0] = UA.slice(); Tp[0] = SP.slice(); Bt[NU] = HB; Tp[NU] = HT;
    P = coons(Lf, Rt, Bt, Tp);
    var GS = grid(NA + 1, NU + 1);
    for (k = 0; k <= NA; k++) for (i = 0; i <= NU; i++) {
      var q3 = k * (NU + 1) + i;
      GS.x[q3] = P[k][i][0]; GS.y[q3] = P[k][i][1];
      if (k === 0 || k === NA) GS.sil[q3] = 1;
      if (i === 0 || k === 0) GS.seamA[q3] = 1;
    }

    // ---- surfaces ----
    var avgS = (sx + sz) / 2;
    function surface(G, dir) { // -> {P: scaled positions, N: analytic normals (scaled), raw: adult points}
      var n = G.nr * G.nc, Pp = new Float64Array(n * 3), Nn = new Float64Array(n * 3), q, hint = NaN, s;
      for (q = 0; q < n; q++) {
        if (q % G.nc === 0) hint = NaN;
        s = point(G.x[q], G.y[q], dir, G.sil[q], hint);
        hint = s.z;
        Pp[3 * q] = s.p[0] * sx; Pp[3 * q + 1] = s.p[1] * sy; Pp[3 * q + 2] = s.p[2] * sz;
        var nx = s.n[0] / sx, ny = s.n[1] / sy, nz = s.n[2] / sz, l = Math.sqrt(nx * nx + ny * ny + nz * nz) || 1;
        Nn[3 * q] = nx / l; Nn[3 * q + 1] = ny / l; Nn[3 * q + 2] = nz / l;
      }
      return { P: Pp, N: Nn };
    }
    var SF = surface(GF, 1), SB = surface(GB, -1), SSF = surface(GS, 1), SSB = surface(GS, -1);

    // ---- print charts: s = across (arc length), t = down from the anchor (arc length) ----
    function chart(dir, yAnchor) {
      var nx = 25, ny = Math.ceil((yH + 1.5 + 1) / 0.5) + 1, Sv = new Float64Array(nx * ny), Tc = new Float64Array(ny), prev = null, hint, q, jj, ii2, pt, last, L;
      for (jj = 0; jj < ny; jj++) {
        var yv = -1 + jj * 0.5; hint = NaN; last = null; L = 0;
        for (ii2 = 0; ii2 < nx; ii2++) {
          var xv = ii2 * 0.5, zz = hz(xv, yv, dir, hint);
          if (zz === zz) {
            hint = zz;
            var n = gradN(xv, yv, zz), w = wrinkle(xv, yv, dir) * smooth(0.12, 0.55, Math.abs(n[2])) * smooth(0, 0.9, armDist(xv, yv));
            pt = [(xv + n[0] * w) * sx, (yv + n[1] * w) * sy, (zz + n[2] * w) * sz];
            if (last) L += Math.sqrt((pt[0] - last[0]) * (pt[0] - last[0]) + (pt[1] - last[1]) * (pt[1] - last[1]) + (pt[2] - last[2]) * (pt[2] - last[2]));
            last = pt;
            if (ii2 === 0) { if (prev) Tc[jj] = Tc[jj - 1] + Math.sqrt((pt[1] - prev[1]) * (pt[1] - prev[1]) + (pt[2] - prev[2]) * (pt[2] - prev[2])); prev = pt; }
          } else { L += 0.5 * sx; if (ii2 === 0 && jj > 0) Tc[jj] = Tc[jj - 1] + 0.5 * sy; }
          Sv[jj * nx + ii2] = L;
        }
      }
      var fa = (yAnchor + 1) / 0.5, ja = Math.min(ny - 2, Math.floor(fa)), ta = Tc[ja] + (Tc[ja + 1] - Tc[ja]) * (fa - ja);
      return function (x, y) { // adult (x >= 0, y) -> [s, t] in true inches
        var fx = Math.min(nx - 1.0001, Math.max(0, x / 0.5)), fy = Math.min(ny - 1.0001, Math.max(0, (y + 1) / 0.5)), i0 = fx | 0, j0 = fy | 0, rx = fx - i0, ry = fy - j0,
          s0 = Sv[j0 * nx + i0] + (Sv[j0 * nx + i0 + 1] - Sv[j0 * nx + i0]) * rx, s1 = Sv[(j0 + 1) * nx + i0] + (Sv[(j0 + 1) * nx + i0 + 1] - Sv[(j0 + 1) * nx + i0]) * rx;
        return [s0 + (s1 - s0) * ry, ta - (Tc[j0] + (Tc[j0 + 1] - Tc[j0]) * ry)];
      };
    }
    var chF = chart(1, yNF), chB = chart(-1, yNB);
    // sleeve chart: t along the top of the sleeve from the shoulder seam, s around the sleeve
    var topA = [], topT = [0];
    for (i = 0; i <= NU; i++) {
      q = NA * (NU + 1) + i; topA.push(axA(GS.x[q], GS.y[q]));
      if (i) topT.push(topT[i - 1] + Math.sqrt(Math.pow(SSF.P[3 * q] - SSF.P[3 * q - 3], 2) + Math.pow(SSF.P[3 * q + 1] - SSF.P[3 * q - 2], 2) + Math.pow(SSF.P[3 * q + 2] - SSF.P[3 * q - 1], 2)));
    }
    var q;
    function sleeveST(Pa, dir) { // Pa: adult point on the front (dir 1) or back (-1) half -> [s (+ toward the back), t]
      var a = axA(Pa[0], Pa[1]), qx = MID[0] + a * ADX, qy = MID[1] + a * ADY, c1 = (Pa[0] - qx) * -ADY + (Pa[1] - qy) * ADX, c2 = Pa[2] - MID[2],
        th = Math.atan2(c2, c1), rho = Math.sqrt(c1 * c1 + c2 * c2), t, m = topA.length - 1, ii3;
      if (dir > 0 && th < -PI / 2) th += 2 * PI; else if (dir < 0 && th > PI / 2) th -= 2 * PI; // no wrap at the underarm
      if (a <= topA[0]) t = topT[0] + (a - topA[0]) * (topT[1] - topT[0]) / ((topA[1] - topA[0]) || 1);
      else if (a >= topA[m]) t = topT[m] + (a - topA[m]) * (topT[m] - topT[m - 1]) / ((topA[m] - topA[m - 1]) || 1);
      else { for (ii3 = 1; ii3 < m && a > topA[ii3]; ii3++); t = topT[ii3 - 1] + (topT[ii3] - topT[ii3 - 1]) * (a - topA[ii3 - 1]) / ((topA[ii3] - topA[ii3 - 1]) || 1); }
      return [-rho * th * avgS, t];
    }

    // ---- meshes ----
    function seamDist(G, S, mask) { // 3D distance along grid lines to the nearest masked vertex (two sweeps each way)
      var n = G.nr * G.nc, D = new Float64Array(n), P = S.P, H = new Float64Array(n), V = new Float64Array(n), q, rr, cc, a, b, e, dx, dy, dz;
      for (q = 0; q < n; q++) {
        D[q] = mask[q] ? 0 : 1e9;
        if (q % G.nc < G.nc - 1) { dx = P[3 * q + 3] - P[3 * q]; dy = P[3 * q + 4] - P[3 * q + 1]; dz = P[3 * q + 5] - P[3 * q + 2]; H[q] = Math.sqrt(dx * dx + dy * dy + dz * dz); }
        if (q + G.nc < n) { e = 3 * (q + G.nc); dx = P[e] - P[3 * q]; dy = P[e + 1] - P[3 * q + 1]; dz = P[e + 2] - P[3 * q + 2]; V[q] = Math.sqrt(dx * dx + dy * dy + dz * dz); }
      }
      for (var pass = 0; pass < 2; pass++) {
        for (rr = 0; rr < G.nr; rr++) for (cc = 1; cc < G.nc; cc++) { a = rr * G.nc + cc - 1; b = a + 1; if (D[a] + H[a] < D[b]) D[b] = D[a] + H[a]; }
        for (rr = 0; rr < G.nr; rr++) for (cc = G.nc - 1; cc > 0; cc--) { a = rr * G.nc + cc - 1; b = a + 1; if (D[b] + H[a] < D[a]) D[a] = D[b] + H[a]; }
        for (q = G.nc; q < n; q++) { a = q - G.nc; if (D[a] + V[a] < D[q]) D[q] = D[a] + V[a]; }
        for (q = n - 1; q >= G.nc; q--) { a = q - G.nc; if (D[q] + V[a] < D[a]) D[a] = D[q] + V[a]; }
      }
      return D;
    }
    function part() { return { pos: [], nrm: [], uv: [], misc: [], idx: [], fix: [] }; }
    // add grid G with surface S to part M; mirror: x -> -x; st(q) -> [s, t] chart inches; misc = [seam, side seam, hem, ao]
    function addGrid(M, G, S, mirror, st, hem, sA, sB, aoV) {
      var base = M.pos.length / 3, n = G.nr * G.nc, q, rr, cc, m = mirror ? -1 : 1, fixed = [];
      for (q = 0; q < n; q++) {
        M.pos.push(S.P[3 * q] * m, S.P[3 * q + 1], S.P[3 * q + 2]);
        M.nrm.push(0, 0, 0);
        var u = st(q); M.uv.push(u[0] * m, u[1]);
        M.misc.push(Math.min(sA[q], 9), Math.min(sB[q], 9), hem(q), aoV);
        if (G.sil[q] || G.seamA[q]) fixed.push(q); // seams shared with another mesh: the form's own normal
      }
      var I = [];
      for (rr = 0; rr < G.nr - 1; rr++) for (cc = 0; cc < G.nc - 1; cc++) {
        var a = rr * G.nc + cc, b = a + 1, c2 = a + G.nc + 1, d = a + G.nc;
        I.push(a, b, c2, a, c2, d);
      }
      // orientation: compare a mid triangle's normal with the analytic normal there
      var t0 = (Math.floor(G.nr / 2) * (G.nc - 1) + Math.floor(G.nc / 3)) * 6, A = I[t0], B = I[t0 + 1], C = I[t0 + 2],
        ux = S.P[3 * B] - S.P[3 * A], uy = S.P[3 * B + 1] - S.P[3 * A + 1], uz = S.P[3 * B + 2] - S.P[3 * A + 2],
        vx = S.P[3 * C] - S.P[3 * A], vy = S.P[3 * C + 1] - S.P[3 * A + 1], vz = S.P[3 * C + 2] - S.P[3 * A + 2],
        flip = ((uy * vz - uz * vy) * S.N[3 * A] + (uz * vx - ux * vz) * S.N[3 * A + 1] + (ux * vy - uy * vx) * S.N[3 * A + 2]) < 0;
      if (mirror) flip = !flip;
      for (q = 0; q < I.length; q += 3) {
        if (flip) M.idx.push(base + I[q], base + I[q + 2], base + I[q + 1]); else M.idx.push(base + I[q], base + I[q + 1], base + I[q + 2]);
      }
      for (q = 0; q < fixed.length; q++) M.fix.push(base + fixed[q], S.N[3 * fixed[q]] * m, S.N[3 * fixed[q] + 1], S.N[3 * fixed[q] + 2]);
      // the centre line (x = 0) of a torso half: no sideways tilt
      for (q = 0; q < n; q++) if (Math.abs(G.x[q]) < 1e-9 && !G.sil[q]) M.fix.push(base + q, 0, NaN, NaN);
    }
    function finish(M) { // area-weighted vertex normals, then the analytic seam normals; typed arrays
      var P = M.pos, N = M.nrm, I = M.idx, q, a, b, c3;
      for (q = 0; q < I.length; q += 3) {
        a = 3 * I[q]; b = 3 * I[q + 1]; c3 = 3 * I[q + 2];
        var ux = P[b] - P[a], uy = P[b + 1] - P[a + 1], uz = P[b + 2] - P[a + 2], vx = P[c3] - P[a], vy = P[c3 + 1] - P[a + 1], vz = P[c3 + 2] - P[a + 2],
          nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
        N[a] += nx; N[a + 1] += ny; N[a + 2] += nz; N[b] += nx; N[b + 1] += ny; N[b + 2] += nz; N[c3] += nx; N[c3 + 1] += ny; N[c3 + 2] += nz;
      }
      for (q = 0; q < M.fix.length; q += 4) {
        a = 3 * M.fix[q];
        if (M.fix[q + 2] !== M.fix[q + 2]) N[a] = 0; else { N[a] = M.fix[q + 1]; N[a + 1] = M.fix[q + 2]; N[a + 2] = M.fix[q + 3]; }
      }
      for (q = 0; q < N.length; q += 3) { var l = Math.sqrt(N[q] * N[q] + N[q + 1] * N[q + 1] + N[q + 2] * N[q + 2]) || 1; N[q] /= l; N[q + 1] /= l; N[q + 2] /= l; }
      return { pos: new Float32Array(P), nrm: new Float32Array(N), uv: new Float32Array(M.uv), misc: new Float32Array(M.misc),
        idx: P.length / 3 > 65535 ? new Uint32Array(I) : new Uint16Array(I) };
    }
    function adultOf(S, q) { return [S.P[3 * q] / sx, S.P[3 * q + 1] / sy, S.P[3 * q + 2] / sz]; }
    var hemTorso = function (S) { return function (q) { return S.P[3 * q + 1]; }; };
    var dFA = seamDist(GF, SF, GF.seamA), dFB = seamDist(GF, SF, GF.side), dBA = seamDist(GB, SB, GB.seamA), dBB = seamDist(GB, SB, GB.side);
    var mF = part(), mB = part(), mL = part(), mR = part();
    var stF = function (q) { return chF(GF.x[q], GF.y[q]); }, stB = function (q) { var u = chB(GB.x[q], GB.y[q]); return [-u[0], u[1]]; };
    addGrid(mF, GF, SF, false, stF, hemTorso(SF), dFA, dFB, 1); addGrid(mF, GF, SF, true, stF, hemTorso(SF), dFA, dFB, 1);
    addGrid(mB, GB, SB, false, stB, hemTorso(SB), dBA, dBB, 1); addGrid(mB, GB, SB, true, stB, hemTorso(SB), dBA, dBB, 1);
    var sdF = seamDist(GS, SSF, GS.seamA.map(function (v2, q4) { return (q4 % (NU + 1) === 0 || q4 < NU + 1) ? 1 : 0; })),
      sdB = seamDist(GS, SSB, GS.seamA.map(function (v2, q4) { return (q4 % (NU + 1) === 0 || q4 < NU + 1) ? 1 : 0; })),
      none = new Float64Array(GS.nr * GS.nc).fill(9);
    function hemS(S) { return function (q) { var p = adultOf(S, q); return (A_HEM - axA(p[0], p[1])) * avgS; }; }
    function stS(S, dir) { return function (q) { return sleeveST(adultOf(S, q), dir); }; }
    addGrid(mL, GS, SSF, false, stS(SSF, 1), hemS(SSF), sdF, none, 1); addGrid(mL, GS, SSB, false, stS(SSB, -1), hemS(SSB), sdB, none, 1);
    addGrid(mR, GS, SSF, true, stS(SSF, 1), hemS(SSF), sdF, none, 1); addGrid(mR, GS, SSB, true, stS(SSB, -1), hemS(SSB), sdB, none, 1);

    // ---- rib collar along the neckline, and thin hem edges ----
    var loop = [], ncF = GF.nc, rF0 = rowsF.length - 1;
    function P3(S, q, m) { return [S.P[3 * q] * m, S.P[3 * q + 1], S.P[3 * q + 2], S.N[3 * q] * m, S.N[3 * q + 1], S.N[3 * q + 2]]; }
    for (k = 0; k <= K1; k++) loop.push(P3(SF, (rF0 + k) * ncF, 1));
    var rB = GB.nr - 1;
    for (i = NC - 1; i >= 0; i--) loop.push(P3(SB, rB * ncF + i, 1));
    for (i = 1; i <= NC; i++) loop.push(P3(SB, rB * ncF + i, -1));
    for (k = K1 - 1; k >= 1; k--) loop.push(P3(SF, (rF0 + k) * ncF, -1));
    var collar = buildCollar(loop, Z.rib, (sx + sy + sz) / 3);
    var rims = part();
    function rim(list) { // a narrow strip turning in at an open edge (fabric thickness)
      var base = rims.pos.length / 3, q5, nl = list.length;
      for (q5 = 0; q5 < nl; q5++) {
        var e = list[q5];
        rims.pos.push(e[0], e[1], e[2], e[0] - e[3] * 0.07, e[1] - e[4] * 0.07 + 0.02, e[2] - e[5] * 0.07);
        rims.nrm.push(0, 0, 0, 0, 0, 0); rims.uv.push(-99, -99, -99, -99); rims.misc.push(9, 9, 0, 0.8, 9, 9, 0, 0.7);
        if (q5) rims.idx.push(base + 2 * q5 - 2, base + 2 * q5 - 1, base + 2 * q5, base + 2 * q5 - 1, base + 2 * q5 + 1, base + 2 * q5);
      }
    }
    var hemL = [];
    for (i = 0; i <= NC; i++) hemL.push(P3(SF, i, 1));
    for (i = NC; i >= 0; i--) hemL.push(P3(SB, i, 1));
    for (i = 0; i <= NC; i++) hemL.push(P3(SB, i, -1));
    for (i = NC; i >= 0; i--) hemL.push(P3(SF, i, -1));
    rim(hemL);
    var sl = [];
    for (k = 0; k <= NA; k++) sl.push(P3(SSF, k * (NU + 1) + NU, 1));
    for (k = NA; k >= 0; k--) sl.push(P3(SSB, k * (NU + 1) + NU, 1));
    rim(sl); rim(sl.map(function (e) { return [-e[0], e[1], e[2], -e[3], e[4], e[5]]; }));
    var g = { size: size, front: finish(mF), back: finish(mB), sleeveL: finish(mL), sleeveR: finish(mR), collar: collar, rims: finish(rims) };
    // bounds (true inches) and handy numbers
    var bb = [1e9, 1e9, 1e9, -1e9, -1e9, -1e9];
    ["front", "back", "sleeveL", "sleeveR", "collar"].forEach(function (nm) {
      var p = g[nm].pos;
      for (var q6 = 0; q6 < p.length; q6 += 3) for (var d = 0; d < 3; d++) { if (p[q6 + d] < bb[d]) bb[d] = p[q6 + d]; if (p[q6 + d] > bb[d + 3]) bb[d + 3] = p[q6 + d]; }
    });
    g.box = bb;
    g.keys = { HPS: [HPS[0] * sx, HPS[1] * sy], SP: [SP[0] * sx, SP[1] * sy], UA: [UA[0] * sx, UA[1] * sy], HT: [HT[0] * sx, HT[1] * sy], HB: [HB[0] * sx, HB[1] * sy],
      neckFront: yNF * sy, neckBack: yNB * sy, length: yH * sy, sleeveTop: topT[NU] };
    GCACHE[size] = g;
    return g;
  }
  // the rib collar: a folded band standing up from the neckline seam (loop of [x, y, z, nx, ny, nz], true inches)
  function buildCollar(L0, H, sc) {
    var L = [], n0 = L0.length, i, k, m;
    for (i = 0; i < n0; i++) { // Catmull-Rom: one extra point between neighbours
      var a = L0[(i - 1 + n0) % n0], b = L0[i], c = L0[(i + 1) % n0], d = L0[(i + 2) % n0], h = [];
      L.push(b);
      for (k = 0; k < 6; k++) h.push(k < 3 ? 0.5 * (2 * b[k] + (c[k] - a[k]) * 0.5 + (2 * a[k] - 5 * b[k] + 4 * c[k] - d[k]) * 0.25 + (-a[k] + 3 * b[k] - 3 * c[k] + d[k]) * 0.125) : (b[k] + c[k]) / 2);
      L.push(h);
    }
    var n = L.length, th = 0.065, prof = [[0.03, -0.05, 1], [th, 0.1, 1], [th * 1.04, H * 0.5, 1], [th, H - th, 1]], pos = [], nrm = [], uv = [], misc = [], idx = [], cum = 0, zc = 0;
    for (i = 0; i <= 4; i++) { var ang = PI * (i + 1) / 6; prof.push([th * Math.cos(ang), H - th + th * Math.sin(ang), 0.95]); }
    prof.push([-th, H - th, 0.86], [-th, H * 0.5, 0.8], [-th, 0.06, 0.76], [-th * 0.8, -0.2, 0.72]);
    var np = prof.length, pl = [0];
    for (k = 1; k < np; k++) pl.push(pl[k - 1] + hyp(prof[k][0] - prof[k - 1][0], prof[k][1] - prof[k - 1][1]));
    for (i = 0; i < n; i++) zc += L[i][2] / n;
    for (i = 0; i < n; i++) {
      var p = L[i], pp = L[(i - 1 + n) % n], pn = L[(i + 1) % n], T = [pn[0] - pp[0], pn[1] - pp[1], pn[2] - pp[2]], tl = hyp(T[0], T[1], T[2]) || 1;
      T = [T[0] / tl, T[1] / tl, T[2] / tl];
      if (i) cum += hyp(p[0] - L[i - 1][0], p[1] - L[i - 1][1], p[2] - L[i - 1][2]);
      var N = [p[3], p[4], p[5]], O = [T[1] * N[2] - T[2] * N[1], T[2] * N[0] - T[0] * N[2], T[0] * N[1] - T[1] * N[0]],
        inw = [-p[0], 0, zc - p[2]], il = hyp(inw[0], inw[2]) || 1;
      inw = [inw[0] / il, 0, inw[2] / il];
      if (O[0] * inw[0] * 0.3 + O[1] + O[2] * inw[2] * 0.3 < 0) O = [-O[0], -O[1], -O[2]];
      var W = [0.5 * O[0] + 0.15 * inw[0], 0.5 * O[1] + 1, 0.5 * O[2] + 0.15 * inw[2]], wd = W[0] * T[0] + W[1] * T[1] + W[2] * T[2];
      W = [W[0] - wd * T[0], W[1] - wd * T[1], W[2] - wd * T[2]]; m = hyp(W[0], W[1], W[2]) || 1; W = [W[0] / m, W[1] / m, W[2] / m];
      var Nb = [T[1] * W[2] - T[2] * W[1], T[2] * W[0] - T[0] * W[2], T[0] * W[1] - T[1] * W[0]];
      if (Nb[0] * inw[0] + Nb[2] * inw[2] > 0) Nb = [-Nb[0], -Nb[1], -Nb[2]];
      for (k = 0; k < np; k++) {
        var e = prof[k];
        pos.push(p[0] + Nb[0] * e[0] + W[0] * e[1], p[1] + Nb[1] * e[0] + W[1] * e[1], p[2] + Nb[2] * e[0] + W[2] * e[1]);
        nrm.push(0, 0, 0); uv.push(cum, pl[k]); misc.push(9, 9, 9, e[2]);
      }
    }
    for (i = 0; i < n; i++) for (k = 0; k < np - 1; k++) {
      var a2 = i * np + k, b2 = ((i + 1) % n) * np + k;
      idx.push(a2, b2, b2 + 1, a2, b2 + 1, a2 + 1);
    }
    // orient by the outer face: its normal should point away from the neck
    var t3 = 0, A = idx[t3], B = idx[t3 + 1], C = idx[t3 + 2], P = pos,
      ux = P[3 * B] - P[3 * A], uy = P[3 * B + 1] - P[3 * A + 1], uz = P[3 * B + 2] - P[3 * A + 2], vx = P[3 * C] - P[3 * A], vy = P[3 * C + 1] - P[3 * A + 1], vz = P[3 * C + 2] - P[3 * A + 2],
      cx = uy * vz - uz * vy, cz = ux * vy - uy * vx;
    if (cx * (P[3 * A]) + cz * (P[3 * A + 2] - zc) < 0) for (i = 0; i < idx.length; i += 3) { var t4 = idx[i + 1]; idx[i + 1] = idx[i + 2]; idx[i + 2] = t4; }
    for (i = 0; i < idx.length; i += 3) {
      var a3 = 3 * idx[i], b3 = 3 * idx[i + 1], c3 = 3 * idx[i + 2],
        u1 = P[b3] - P[a3], u2 = P[b3 + 1] - P[a3 + 1], u3 = P[b3 + 2] - P[a3 + 2], w1 = P[c3] - P[a3], w2 = P[c3 + 1] - P[a3 + 1], w3 = P[c3 + 2] - P[a3 + 2],
        n1 = u2 * w3 - u3 * w2, n2 = u3 * w1 - u1 * w3, n3 = u1 * w2 - u2 * w1;
      [a3, b3, c3].forEach(function (o) { nrm[o] += n1; nrm[o + 1] += n2; nrm[o + 2] += n3; });
    }
    for (i = 0; i < nrm.length; i += 3) { m = hyp(nrm[i], nrm[i + 1], nrm[i + 2]) || 1; nrm[i] /= m; nrm[i + 1] /= m; nrm[i + 2] /= m; }
    return { pos: new Float32Array(pos), nrm: new Float32Array(nrm), uv: new Float32Array(uv), misc: new Float32Array(misc), idx: new Uint16Array(idx) };
  }

  /* ================= input helpers ================= */
  function num(v, lo, hi) {
    var n = Number(v);
    return v !== null && v !== "" && v !== true && v !== false && v !== undefined && isFinite(n) && n >= lo && n <= hi ? n : null;
  }
  function str(v) { return typeof v === "string" ? v.toLowerCase().replace(/[\s_\-]+/g, " ").replace(/^\s+|\s+$/g, "") : ""; }
  function hexOf(v) { return typeof v === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v.trim()) ? v.trim() : null; }
  function areaOf(v) {
    var s = str(v).replace(/ /g, "");
    if (s === "front" || s === "fullfront" || s === "leftchest" || s === "chest" || s === "youthfront") return "front";
    if (s === "back" || s === "fullback") return "back";
    if (/^(sleevel|leftsleeve|sleeveleft|lsleeve|left|sleeve)$/.test(s)) return "sleeveL";
    if (/^(sleever|rightsleeve|sleeveright|rsleeve|right)$/.test(s)) return "sleeveR";
    return null;
  }
  function viewName(v) {
    var s = str(v).replace(/ /g, "");
    if (VIEWS.hasOwnProperty(s)) return s;
    if (VIEW_ALIAS.hasOwnProperty(s)) return VIEW_ALIAS[s];
    var a = areaOf(v);
    return a === "sleeveL" ? "left" : a === "sleeveR" ? "right" : a || null;
  }
  function hasThree() {
    var T = root.THREE;
    return !!(T && T.WebGLRenderer && T.OrbitControls && T.BufferGeometry && T.MeshLambertMaterial && T.CanvasTexture && T.Vector4);
  }
  function create(host, opts) {
    try { return !host || !hasThree() ? null : build(host, opts || {}); } catch (e) {
      try { // clean up a half-built viewer so the page can fall back to 2D
        var cs = host.querySelectorAll("canvas[data-ardor-dtf3d='init']"), i, gl, ext;
        for (i = 0; i < cs.length; i++) {
          gl = cs[i].getContext("webgl2") || cs[i].getContext("webgl");
          ext = gl && gl.getExtension("WEBGL_lose_context");
          if (ext) ext.loseContext();
          if (cs[i].parentNode) cs[i].parentNode.removeChild(cs[i]);
        }
      } catch (e2) { }
      return null;
    }
  }
  function rng(seed) { return function () { seed = seed * 16807 % 2147483647; return seed / 2147483647; }; }

  /* ================= canvas textures ================= */
  // jersey knit relief (tile 1 in, 256 px): wales of small loops + fine noise -> tangent space normal map
  function knitCanvas(doc) {
    var N = 256, cv = doc.createElement("canvas"), g, im, d, H = new Float32Array(N * N), r = rng(7), x, y, i;
    cv.width = cv.height = N;
    var noise = new Float32Array(32 * 32);
    for (i = 0; i < noise.length; i++) noise[i] = r();
    function vn(px, py) { // periodic value noise on a 32 x 32 lattice
      var fx = px / N * 32, fy = py / N * 32, ix = Math.floor(fx), iy = Math.floor(fy), tx = fx - ix, ty = fy - iy,
        a = noise[(iy & 31) * 32 + (ix & 31)], b = noise[(iy & 31) * 32 + ((ix + 1) & 31)], c = noise[((iy + 1) & 31) * 32 + (ix & 31)], e = noise[((iy + 1) & 31) * 32 + ((ix + 1) & 31)];
      tx = tx * tx * (3 - 2 * tx); ty = ty * ty * (3 - 2 * ty);
      return a + (b - a) * tx + (c - a) * ty + (a - b - c + e) * tx * ty;
    }
    for (y = 0; y < N; y++) for (x = 0; x < N; x++) {
      var w = x * 16 / N, cyc = y * 22 / N, fx = w - Math.floor(w), leg = fx < 0.5 ? fx * 2 : (1 - fx) * 2, row = cyc - Math.floor(cyc);
      H[y * N + x] = 0.55 * Math.sin(PI * leg) * (0.75 + 0.25 * Math.sin(2 * PI * (row + (fx < 0.5 ? 0.25 : -0.25)))) + 0.35 * vn(x, y) + 0.1 * r();
    }
    g = cv.getContext("2d"); im = g.createImageData(N, N); d = im.data;
    for (y = 0; y < N; y++) for (x = 0; x < N; x++) {
      var dx = (H[y * N + ((x + 1) & (N - 1))] - H[y * N + ((x - 1) & (N - 1))]) * 1.6, dy = (H[((y + 1) & (N - 1)) * N + x] - H[((y - 1) & (N - 1)) * N + x]) * 1.6,
        l = Math.sqrt(dx * dx + dy * dy + 1), o = 4 * (y * N + x);
      d[o] = (-dx / l * 0.5 + 0.5) * 255; d[o + 1] = (dy / l * 0.5 + 0.5) * 255; d[o + 2] = (1 / l * 0.5 + 0.5) * 255; d[o + 3] = 255;
    }
    g.putImageData(im, 0, 0);
    return cv;
  }
  // red: heather fibres (short streaks along the knit rows); green: soft cotton mottle. Tile 4 in, 512 px, 0.5 = neutral
  function fabricCanvas(doc) {
    var N = 512, cv = doc.createElement("canvas"), g = (cv.width = cv.height = N, cv.getContext("2d")), r = rng(23), i, k;
    g.fillStyle = "rgb(128,128,0)"; g.fillRect(0, 0, N, N);
    g.globalCompositeOperation = "lighter";
    for (i = 0; i < 70; i++) { // mottle in green (soft blobs, wrapped)
      var bx = r() * N, by = r() * N, br = 20 + r() * 60, gr = g.createRadialGradient(0, 0, 0, 0, 0, br), up = r() > 0.5, al = 0.05 + r() * 0.07;
      gr.addColorStop(0, "rgba(0," + (up ? 255 : 0) + ",0," + al + ")"); gr.addColorStop(1, "rgba(0,0,0,0)");
      g.fillStyle = gr;
      for (k = 0; k < 4; k++) { g.save(); g.translate(bx + (k & 1 ? -N : 0), by + (k & 2 ? -N : 0)); g.fillRect(-br, -br, 2 * br, 2 * br); g.restore(); }
    }
    g.globalCompositeOperation = "source-over";
    var im = g.getImageData(0, 0, N, N), d = im.data;
    for (i = 0; i < 9000; i++) { // heather fibres in red: light and dark streaks
      var len = 4 + r() * 26, x0 = r() * N, y0 = Math.floor(r() * N), v = r() > 0.5 ? 128 + 50 + r() * 75 : 128 - 50 - r() * 70, th = r() > 0.8 ? 2 : 1, t;
      for (t = 0; t < len; t++) for (k = 0; k < th; k++) {
        var px = Math.floor(x0 + t) & (N - 1), py = (y0 + k) & (N - 1), o = 4 * (py * N + px), e = Math.min(1, Math.min(t, len - t) / 3);
        d[o] = d[o] + (v - d[o]) * e;
      }
    }
    for (i = 0; i < d.length; i += 4) d[i] = d[i] + (r() - 0.5) * 30;
    g.putImageData(im, 0, 0);
    return cv;
  }
  // 1x1 rib for the collar: ribs run up the band (tile 0.6 in, 8 ribs)
  function ribCanvas(doc) {
    var N = 64, cv = doc.createElement("canvas"), g = (cv.width = cv.height = N, cv.getContext("2d")), im = g.createImageData(N, N), d = im.data, x, y;
    for (y = 0; y < N; y++) for (x = 0; x < N; x++) {
      var s = Math.cos(2 * PI * x * 8 / N), dx = -Math.sin(2 * PI * x * 8 / N) * 0.9, l = Math.sqrt(dx * dx + 1), o = 4 * (y * N + x);
      d[o] = (-dx / l * 0.5 + 0.5) * 255; d[o + 1] = 128 + s * 6; d[o + 2] = (1 / l * 0.5 + 0.5) * 255; d[o + 3] = 255;
    }
    g.putImageData(im, 0, 0);
    return cv;
  }

  /* ================= viewer ================= */
  function build(host, opts) {
    var THREE = root.THREE, doc = host.ownerDocument || document, win = doc.defaultView || root,
      bg = hexOf(opts.background) || DEFAULT_BG, canvas = doc.createElement("canvas");
    canvas.setAttribute("aria-label", "3D preview of your t-shirt. Drag to turn it.");
    canvas.setAttribute("data-ardor-dtf3d", "init");
    canvas.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;inset:0;width:100%;height:100%;display:block;touch-action:none;outline:none;cursor:grab;";
    var attrs = { alpha: false, antialias: true, depth: true, stencil: false, premultipliedAlpha: true, preserveDrawingBuffer: false }, gl = null;
    try { gl = canvas.getContext("webgl2", attrs); } catch (e1) { gl = null; }
    if (!gl) try { gl = canvas.getContext("webgl", attrs) || canvas.getContext("experimental-webgl", attrs); } catch (e2) { gl = null; }
    if (!gl) return null;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, context: gl, antialias: true, alpha: false, stencil: false, preserveDrawingBuffer: false });
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.NoToneMapping;
    renderer.setClearColor(new THREE.Color(bg), 1);
    try { if (win.getComputedStyle && win.getComputedStyle(host).position === "static") host.style.position = "relative"; } catch (e3) { }
    host.appendChild(canvas);

    var maxAniso = 1;
    try { maxAniso = renderer.capabilities.getMaxAnisotropy() || 1; } catch (e4) { maxAniso = 1; }
    var canMip = !!renderer.capabilities.isWebGL2, scene = new THREE.Scene(), camera = new THREE.PerspectiveCamera(FOV, 1, 1, 4000), disposed = false;
    scene.add(camera);
    function lin(hex) { var c = new THREE.Color(hex); c.convertSRGBToLinear(); return c; }
    // lights: soft sky/ground fill, a light that follows the camera, a fixed key and a back fill
    var hemi = new THREE.HemisphereLight(lin("#ffffff"), lin("#c9c4ba"), 0.5);
    hemi.position.set(0, 1, 0); scene.add(hemi);
    var head = new THREE.DirectionalLight(0xffffff, 0.3);
    head.position.set(-0.3, 0.5, 1); camera.add(head); camera.add(head.target);
    var key = new THREE.DirectionalLight(0xffffff, 0.34), fill = new THREE.DirectionalLight(0xffffff, 0.24);
    key.position.set(-0.45, 0.6, 0.7); fill.position.set(0.45, 0.45, -0.75);
    scene.add(key); scene.add(fill);

    function tex(c, rep, srgb, wrap) {
      var t = new THREE.CanvasTexture(c);
      t.encoding = srgb ? THREE.sRGBEncoding : THREE.LinearEncoding;
      t.anisotropy = maxAniso;
      t.wrapS = t.wrapT = wrap ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
      if (rep) t.repeat.set(rep, rep);
      t.magFilter = THREE.LinearFilter;
      t.minFilter = canMip || wrap ? THREE.LinearMipmapLinearFilter : THREE.LinearFilter;
      t.generateMipmaps = canMip || wrap;
      return t;
    }
    var knitTex = tex(knitCanvas(doc), 1, false, true), ribTex = tex(ribCanvas(doc), 1 / 0.6, false, true), fabTex = tex(fabricCanvas(doc), 0, false, true),
      blankCv = doc.createElement("canvas");
    blankCv.width = blankCv.height = 2;
    var blankTex = tex(blankCv, 0, false, false);
    var shared = { uFab: { value: fabTex }, uHeather: { value: 0 }, uSheen: { value: 0.02 }, uInside: { value: 0.5 } };
    var VERT_A = "#include <common>\nattribute vec4 misc;\nvarying vec4 vMisc;\nvarying vec2 vPc;",
      VERT_B = "#include <uv_vertex>\nvMisc = misc;\nvPc = uv;",
      FRAG_A = ["#include <common>", "uniform sampler2D uArt; uniform vec4 uArtRect; uniform float uArtOn;",
        "uniform sampler2D uFab; uniform float uHeather; uniform float uSheen; uniform float uInside;",
        "varying vec4 vMisc; varying vec2 vPc;",
        "vec3 dtfLin( vec3 c ) { return mix( c * 0.0773993808, pow( c * 0.9478672986 + 0.0521327014, vec3( 2.4 ) ), step( vec3( 0.04045 ), c ) ); }"].join("\n"),
      FRAG_B = ["vec4 fab = texture2D( uFab, vPc * 0.25 );",
        "float fl = 1.0 + ( fab.r - 0.5 ) * uHeather + ( fab.g - 0.5 ) * 0.08;",
        "float hm = vMisc.z, fw = max( fwidth( hm ), 0.004 );",
        // seams (armhole, shoulder, underarm; faint side seam), double needle hem stitching, the hem fold and edge
        "float sh = 1.0 - 0.28 * ( 1.0 - smoothstep( 0.0, 0.11, vMisc.x ) ) - 0.12 * ( 1.0 - smoothstep( 0.0, 0.07, vMisc.y ) );",
        "sh -= 0.12 * ( 1.0 - smoothstep( 0.0, fw + 0.014, abs( hm - 0.62 ) ) ) + 0.12 * ( 1.0 - smoothstep( 0.0, fw + 0.014, abs( hm - 0.84 ) ) );",
        "sh -= 0.07 * smoothstep( 0.92, 1.02, hm ) * smoothstep( 1.3, 1.04, hm ) + 0.16 * ( 1.0 - smoothstep( 0.0, 0.07, hm ) );",
        "diffuseColor.rgb *= fl * sh * vMisc.w;",
        "if ( ! gl_FrontFacing ) diffuseColor.rgb *= uInside;",
        // the print: true-size rect in the area's chart (inches), art premultiplied in sRGB
        "vec2 pq = ( vPc - uArtRect.xy ) / uArtRect.zw;",
        "vec4 art = texture2D( uArt, vec2( pq.x, 1.0 - pq.y ) );",
        "float pin = step( 0.0, pq.x ) * step( pq.x, 1.0 ) * step( 0.0, pq.y ) * step( pq.y, 1.0 ) * uArtOn * ( gl_FrontFacing ? 1.0 : 0.0 );",
        "float pa = clamp( art.a, 0.0, 1.0 ) * pin;",
        "vec3 pc = dtfLin( clamp( art.rgb / max( art.a, 0.0001 ), 0.0, 1.0 ) ) * mix( 1.0, fl, 0.3 ) * mix( 1.0, sh, 0.7 );",
        "diffuseColor.rgb = mix( diffuseColor.rgb, pc, pa );"].join("\n"),
      FRAG_C = ["#include <aomap_fragment>",
        "float ndv = abs( dot( normal, normalize( vViewPosition ) ) );",
        "reflectedLight.indirectDiffuse += uSheen * pow( 1.0 - ndv, 2.0 ) * vec3( 1.0 ) * ( gl_FrontFacing ? 1.0 : 0.3 );"].join("\n");
    function fabricMat(normalTex, scale) {
      var m = new THREE.MeshLambertMaterial({ color: 0xffffff, side: THREE.DoubleSide, normalMap: normalTex });
      m.normalScale.set(scale, scale);
      m.extensions = { derivatives: true };
      m.userData.u = { uArt: { value: blankTex }, uArtRect: { value: new THREE.Vector4(0, 0, 1, 1) }, uArtOn: { value: 0 } };
      m.onBeforeCompile = function (sh) {
        var k;
        for (k in m.userData.u) if (m.userData.u.hasOwnProperty(k)) sh.uniforms[k] = m.userData.u[k];
        for (k in shared) if (shared.hasOwnProperty(k)) sh.uniforms[k] = shared[k];
        sh.vertexShader = sh.vertexShader.replace("#include <common>", VERT_A).replace("#include <uv_vertex>", VERT_B);
        sh.fragmentShader = sh.fragmentShader.replace("#include <common>", FRAG_A).replace("#include <map_fragment>", FRAG_B)
          .replace("#include <aomap_fragment>", FRAG_C);
      };
      m.customProgramCacheKey = function () { return "ardorDtfFabric1"; };
      return m;
    }
    var MATS = { front: fabricMat(knitTex, 0.35), back: fabricMat(knitTex, 0.35), sleeveL: fabricMat(knitTex, 0.35), sleeveR: fabricMat(knitTex, 0.35),
      rims: fabricMat(knitTex, 0.35), collar: fabricMat(ribTex, 0.55) };
    var groundMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, depthWrite: false, toneMapped: false }),
      groundCv = doc.createElement("canvas");
    groundCv.width = groundCv.height = 1024;
    var groundTex = tex(groundCv, 0, true, false);
    groundMat.map = groundTex;

    var state = { size: "adult", color: "#f6f6f4", heather: false }, sizeBuilt = "", shirtRoot = null, geos = {}, ground = null,
      ptsAll = [], ptsNear = [], cAll = new THREE.Vector3(), target = new THREE.Vector3(0, 15, 0), fitHome = 120, size = { w: 0, h: 0 }, G = null,
      prints = {};
    ["front", "back", "sleeveL", "sleeveR"].forEach(function (a) { prints[a] = { src: null, rect: null, cv: doc.createElement("canvas"), tex: null, ck: "" }; });

    var controls = new THREE.OrbitControls(camera, canvas);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.12;
    controls.rotateSpeed = 0.8;
    controls.zoomSpeed = 0.9;
    controls.minPolarAngle = PI / 2 - EL_MAX;
    controls.maxPolarAngle = PI / 2 - EL_MIN;

    /* ---------- prints ---------- */
    function copyArt(a, force) {
      var P = prints[a], src = P.src, m = MATS[a].userData.u;
      if (!src || !P.rect) { if (P.tex) P.tex.dispose(); P.tex = null; P.ck = ""; m.uArt.value = blankTex; m.uArtOn.value = 0; return; }
      var cap = Math.min(2048, renderer.capabilities.maxTextureSize || 2048, Math.max(256, Math.round(Math.max(P.rect[2], P.rect[3]) * 220))),
        k = Math.min(1, cap / Math.max(src.width, src.height)), cw = Math.max(2, Math.round(src.width * k)), ch = Math.max(2, Math.round(src.height * k)),
        ck = [cw, ch, src.width, src.height].join(",");
      if (!force && P.tex && ck === P.ck) return;
      P.ck = ck;
      if (P.cv.width !== cw || P.cv.height !== ch || !P.tex) {
        P.cv.width = cw; P.cv.height = ch;
        if (P.tex) P.tex.dispose();
        P.tex = tex(P.cv, 0, false, false);
        P.tex.premultiplyAlpha = true;
      } else P.tex.needsUpdate = true;
      var g = P.cv.getContext("2d");
      g.clearRect(0, 0, cw, ch);
      try { g.drawImage(src, 0, 0, cw, ch); } catch (e) { }
      m.uArt.value = P.tex; m.uArtOn.value = 1;
      m.uArtRect.value.set(P.rect[0], P.rect[1], P.rect[2], P.rect[3]);
    }

    /* ---------- the shirt ---------- */
    function geoOf(d) {
      var g = new THREE.BufferGeometry();
      g.setAttribute("position", new THREE.BufferAttribute(d.pos, 3));
      g.setAttribute("normal", new THREE.BufferAttribute(d.nrm, 3));
      g.setAttribute("uv", new THREE.BufferAttribute(d.uv, 2));
      g.setAttribute("misc", new THREE.BufferAttribute(d.misc, 4));
      g.setIndex(new THREE.BufferAttribute(d.idx, 1));
      g.computeBoundingSphere();
      return g;
    }
    function floorY() { return -2.6 * SIZES[state.size].sy; }
    function paintGround(box) {
      var N = groundCv.width, g = groundCv.getContext("2d"), cx = (box[0] + box[3]) / 2, cz = (box[2] + box[5]) / 2,
        R = Math.max(box[3] - box[0], box[5] - box[2]) * 0.62 + 18, s = N / (2 * R), rnd = rng(11), i, k = SIZES[state.size].sx;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.globalCompositeOperation = "source-over";
      g.shadowColor = "rgba(0,0,0,0)"; g.shadowBlur = 0;
      g.clearRect(0, 0, N, N);
      g.fillStyle = "#dad8d3"; g.fillRect(0, 0, N, N);
      for (i = 0; i < 7000; i++) {
        g.fillStyle = rnd() > 0.5 ? "rgba(255,255,255,0.35)" : "rgba(90,88,84,0.14)";
        g.fillRect(rnd() * N, rnd() * N, 1 + rnd() * 1.5, 1 + rnd() * 1.5);
      }
      // soft shadow of the floating shirt
      var OFF = 4096, sh = [[9.5 * k, 4.6 * k, 0.3, 7], [7.5 * k, 3.4 * k, 0.22, 3.5]];
      for (i = 0; i < sh.length; i++) {
        g.save(); g.shadowColor = "rgba(24,24,20," + sh[i][2] + ")"; g.shadowBlur = sh[i][3] * s; g.shadowOffsetX = OFF;
        g.fillStyle = "#000"; g.beginPath(); g.ellipse(N / 2 - OFF, N / 2, sh[i][0] * s, sh[i][1] * s, 0, 0, PI * 2);
        g.fill(); g.restore();
      }
      var fade = g.createRadialGradient(N / 2, N / 2, 0, N / 2, N / 2, N / 2);
      fade.addColorStop(0, "rgba(0,0,0,1)"); fade.addColorStop(0.5, "rgba(0,0,0,1)"); fade.addColorStop(0.76, "rgba(0,0,0,0.5)");
      fade.addColorStop(0.96, "rgba(0,0,0,0)"); fade.addColorStop(1, "rgba(0,0,0,0)");
      g.globalCompositeOperation = "destination-in"; g.fillStyle = fade; g.fillRect(0, 0, N, N);
      g.globalCompositeOperation = "source-over";
      groundTex.needsUpdate = true;
      if (!ground) {
        ground = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), groundMat);
        ground.rotation.x = -PI / 2; ground.renderOrder = -1;
        scene.add(ground);
      }
      ground.scale.set(R, R, 1);
      ground.position.set(cx, floorY(), cz);
    }
    function buildShirt() {
      G = shirt(state.size);
      if (shirtRoot) scene.remove(shirtRoot);
      shirtRoot = new THREE.Group();
      scene.add(shirtRoot);
      if (!geos[state.size]) {
        geos[state.size] = {};
        ["front", "back", "sleeveL", "sleeveR", "collar", "rims"].forEach(function (k) { geos[state.size][k] = geoOf(G[k]); });
      }
      ["front", "back", "sleeveL", "sleeveR", "collar", "rims"].forEach(function (k) { shirtRoot.add(new THREE.Mesh(geos[state.size][k], MATS[k])); });
      var b = G.box, X0 = b[0], X1 = b[3], Z0 = b[2], Z1 = b[5], Y0 = floorY(), Y1 = b[4] + 0.3, mg = 0.03 * Math.max(Y1 - Y0, X1 - X0), i;
      paintGround(b);
      X0 -= mg; X1 += mg; Z0 -= mg; Z1 += mg;
      ptsAll = []; ptsNear = [];
      cAll.set((X0 + X1) / 2, (Y0 + Y1) / 2, (Z0 + Z1) / 2);
      for (i = 0; i < 8; i++) {
        ptsAll.push(new THREE.Vector3(i & 1 ? X1 : X0, i & 2 ? Y1 : Y0, i & 4 ? Z1 : Z0));
        ptsNear.push(new THREE.Vector3(cAll.x + (i & 1 ? 1 : -1) * (X1 - X0) * 0.17, cAll.y + (i & 2 ? 1 : -1) * (Y1 - Y0) * 0.2, cAll.z + (i & 4 ? 1 : -1) * (Z1 - Z0) * 0.2));
      }
      var big = Math.max(Y1 - Y0, X1 - X0, Z1 - Z0);
      camera.near = Math.max(0.2, big / 300); camera.far = big * 30;
      camera.updateProjectionMatrix();
    }
    function recolor() {
      var c = lin(state.color), k, l = 0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b;
      if (l < 0.03) { c.multiplyScalar(Math.min(2.2, Math.pow(0.03 / Math.max(l, 0.002), 0.6))); l = 0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b; } // cotton is never pure black
      for (k in MATS) if (MATS.hasOwnProperty(k)) MATS[k].color.copy(c);
      MATS.collar.color.multiplyScalar(0.94);
      shared.uHeather.value = state.heather ? 0.75 : 0.1;
      shared.uSheen.value = 0.012 + 0.09 * Math.pow(1 - Math.min(1, l * 1.6), 2);
    }

    /* ---------- camera (same behaviour as the other Ardor 3D viewers) ---------- */
    var raf = 0, tween = null, backupT = 0;
    function now() { return win.performance && win.performance.now ? win.performance.now() : Date.now(); }
    function invalidate() {
      if (disposed) return;
      if (!raf) raf = win.requestAnimationFrame(frame);
      if (!backupT) backupT = win.setTimeout(function () { backupT = 0; if (raf) { win.cancelAnimationFrame(raf); raf = 0; frame(); } }, 250);
    }
    function draw() { try { renderer.render(scene, camera); } catch (e) { } }
    function frame() {
      raf = 0;
      if (disposed || (!size.w && !measure())) return;
      var moving = !!tween;
      if (tween) stepTween();
      controls.update();
      holdInView();
      draw();
      if (tween || moving) invalidate();
    }
    function getSph() {
      var ox = camera.position.x - target.x, oy = camera.position.y - target.y, oz = camera.position.z - target.z,
        r = Math.sqrt(ox * ox + oy * oy + oz * oz) || 1;
      return { az: Math.atan2(ox, oz), el: Math.asin(Math.max(-1, Math.min(1, oy / r))), r: r };
    }
    function setSph(az, el, r) {
      var ce = Math.cos(el);
      camera.position.set(target.x + r * ce * Math.sin(az), target.y + r * Math.sin(el), target.z + r * ce * Math.cos(az));
      camera.lookAt(target);
    }
    function fitDistance(az, el, aspect, share, pts, c) {
      var tv = Math.tan(FOV * PI / 360), th = tv * (aspect || 1), ce = Math.cos(el), se = Math.sin(el), sa = Math.sin(az),
        ca = Math.cos(az), m = 1 / (share || 1), best = 1, i, x, y, z, cx, cy, cz, d;
      for (i = 0; i < pts.length; i++) {
        x = pts[i].x - c.x; y = pts[i].y - c.y; z = pts[i].z - c.z;
        cx = x * ca - z * sa; cy = -x * se * sa + y * ce - z * se * ca; cz = x * ce * sa + y * se + z * ce * ca;
        d = cz + Math.max(Math.abs(cx) * m / th, Math.abs(cy) * m / tv);
        if (d > best) best = d;
      }
      return best;
    }
    function aspectNow() { return size.w > 0 && size.h > 0 ? size.w / size.h : 1.3; }
    function farFor(az, el, asp) { return fitDistance(az, el, asp || aspectNow(), FILL_HOME, ptsAll, cAll); }
    function nearFor(az, el, asp) { return Math.min(farFor(az, el, asp) * 0.9, fitDistance(az, el, asp || aspectNow(), FILL_NEAR, ptsNear, cAll)); }
    function place(az, el, r) { target.copy(cAll); controls.target.copy(target); setSph(az, el, r); }
    function viewOf(name) { var v = VIEWS[viewName(name) || "home"] || VIEWS.home; return { az: v[0], el: v[1] }; }
    function updateLimits() {
      var s = getSph(), h = viewOf("home");
      fitHome = farFor(h.az, h.el);
      controls.minDistance = nearFor(s.az, s.el);
      controls.maxDistance = Math.max(fitDistance(0, 0.1, aspectNow(), FILL_FAR, ptsAll, cAll), fitHome * 1.3);
    }
    function clampR(r, az, el) { return Math.max(nearFor(az, el), Math.min(controls.maxDistance, r)); }
    function holdInView() {
      var s = getSph(), near = nearFor(s.az, s.el);
      controls.minDistance = near;
      if (!tween && s.r < near - 0.01) setSph(s.az, s.el, near);
    }
    function stepTween() {
      var t = (now() - tween.t0) / tween.ms;
      if (t >= 1) t = 1;
      var k = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      place(tween.a.az + (tween.b.az - tween.a.az) * k, tween.a.el + (tween.b.el - tween.a.el) * k, tween.a.r + (tween.b.r - tween.a.r) * k);
      if (t >= 1) tween = null;
    }
    var reduced = false;
    try { reduced = !!(win.matchMedia && win.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e5) { reduced = false; }
    function tweenTo(az, el, r, ms) {
      var a = getSph(), d = az - a.az;
      while (d > PI) d -= PI * 2;
      while (d < -PI) d += PI * 2;
      tween = { a: a, b: { az: a.az + d, el: el, r: r }, t0: now(), ms: reduced ? 1 : ms };
      invalidate();
    }
    function measure() {
      var w = host.clientWidth | 0, h = host.clientHeight | 0;
      if (w < 2 || h < 2) return false;
      var pr = Math.min(2, Math.max(1, win.devicePixelRatio || 1));
      if (w === size.w && h === size.h && pr === renderer.getPixelRatio()) return false;
      var oldFit = fitHome, had = size.w > 0;
      size.w = w; size.h = h;
      renderer.setPixelRatio(pr); renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      updateLimits();
      var s = getSph();
      if (had && !tween) place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
      else if (had && tween) tween.b.r = tween.b.r * fitHome / oldFit;
      else { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
      controls.update();
      return true;
    }
    function onControlsChange() { invalidate(); }
    function onControlsStart() { tween = null; canvas.style.cursor = "grabbing"; }
    function onControlsEnd() { canvas.style.cursor = "grab"; }
    controls.addEventListener("change", onControlsChange);
    controls.addEventListener("start", onControlsStart);
    controls.addEventListener("end", onControlsEnd);

    // render with a temporary camera (snapshot / project), then put everything back
    function withCamera(w, h, vName, fn) {
      var oldPR = renderer.getPixelRatio(), oldSize = renderer.getSize(new THREE.Vector2()), oldAspect = camera.aspect,
        oldPos = camera.position.clone(), oldTarget = target.clone(), s = getSph(), out = null;
      try {
        var cap = Math.min(4096, renderer.capabilities.maxTextureSize || 4096);
        w = Math.max(16, Math.min(cap, Math.round(w || size.w || 800)));
        h = Math.max(16, Math.min(cap, Math.round(h || size.h || 600)));
        renderer.setPixelRatio(1); renderer.setSize(w, h, false);
        camera.aspect = w / h; camera.updateProjectionMatrix();
        var vn = typeof vName === "string" ? viewName(vName) : null;
        if (vn) { var v = viewOf(vn); place(v.az, v.el, farFor(v.az, v.el, w / h)); }
        else place(s.az, s.el, s.r * farFor(s.az, s.el, w / h) / farFor(s.az, s.el, oldAspect || 1));
        camera.updateMatrixWorld(true);
        out = fn(w, h);
      } catch (e) { out = null; }
      try {
        renderer.setPixelRatio(oldPR); renderer.setSize(oldSize.x, oldSize.y, false);
        camera.aspect = oldAspect; camera.updateProjectionMatrix();
        target.copy(oldTarget); controls.target.copy(target); camera.position.copy(oldPos); camera.lookAt(target);
        renderer.render(scene, camera);
      } catch (e2) { }
      return out;
    }
    // chart point (inches) on an area -> world point (barycentric search in the area's chart)
    function probe(area, xIn, yIn) {
      var a = areaOf(area), d = a && G ? G[a] : null, I, U, P, i, best = null;
      if (!d) return null;
      I = d.idx; U = d.uv; P = d.pos;
      for (i = 0; i < I.length; i += 3) {
        var A = I[i], B = I[i + 1], C = I[i + 2], ax = U[2 * A], ay = U[2 * A + 1], bx = U[2 * B] - ax, by = U[2 * B + 1] - ay, cx = U[2 * C] - ax, cy = U[2 * C + 1] - ay,
          px = xIn - ax, py = yIn - ay, den = bx * cy - by * cx;
        if (Math.abs(den) < 1e-12) continue;
        var v = (px * cy - py * cx) / den, w = (bx * py - by * px) / den;
        if (v >= -1e-6 && w >= -1e-6 && v + w <= 1 + 1e-6) {
          var u = 1 - v - w;
          best = { x: u * P[3 * A] + v * P[3 * B] + w * P[3 * C], y: u * P[3 * A + 1] + v * P[3 * B + 1] + w * P[3 * C + 1], z: u * P[3 * A + 2] + v * P[3 * B + 2] + w * P[3 * C + 2] };
          break;
        }
      }
      return best;
    }

    var api = {
      set: function (o) {
        if (disposed || !o || typeof o !== "object") return;
        var s0 = getSph(), oldFit = fitHome, first = !sizeBuilt, sz = o.size !== undefined ? (/youth|kid|child|boy|girl|^y/.test(str(o.size)) ? "youth" : "adult") : state.size;
        if (o.color !== undefined) {
          var h = hexOf(o.color), n = str(o.color);
          if (h) state.color = h;
          else if (COLORS.hasOwnProperty(n)) state.color = COLORS[n];
          else if (/heather/.test(n)) state.color = COLORS["heather gray"];
          if (o.heather === undefined) state.heather = /heather/.test(n);
        }
        if (o.heather !== undefined) state.heather = !!o.heather;
        state.size = sz;
        if (sz !== sizeBuilt) {
          buildShirt(); sizeBuilt = sz;
          updateLimits();
          if (first) { var hv = viewOf("home"); place(hv.az, hv.el, fitHome); }
          else { if (tween) tween.b.r = tween.b.r * fitHome / oldFit; place(s0.az, s0.el, clampR(s0.r * fitHome / oldFit, s0.az, s0.el)); }
          controls.update();
        }
        recolor();
        invalidate();
      },
      setPrint: function (area, cv, o) {
        var a = areaOf(area);
        if (disposed || !a) return;
        var P = prints[a];
        if (!cv || !(cv.width > 0) || !(cv.height > 0)) { P.src = null; P.rect = null; copyArt(a); invalidate(); return; }
        o = o && typeof o === "object" ? o : {};
        var pre = PRESETS[state.size][a === "front" ? "fullFront" : a === "back" ? "fullBack" : a],
          w = num(o.widthIn, 0.05, 60), h = num(o.heightIn, 0.05, 80), x = num(o.xIn, -60, 60), y = num(o.yIn, -40, 80);
        if (w === null && h === null) w = pre.widthIn;
        if (w === null) w = h * cv.width / cv.height;
        if (h === null) h = w * cv.height / cv.width;
        P.src = cv;
        P.rect = [(x === null ? 0 : x) - w / 2, y === null ? pre.yIn : y, w, h];
        copyArt(a, true);
        invalidate();
      },
      refresh: function (area) { // after redrawing a canvas already passed (a new size is fine)
        if (disposed) return;
        var a = areaOf(area);
        (a ? [a] : ["front", "back", "sleeveL", "sleeveR"]).forEach(function (k) { copyArt(k, true); });
        invalidate();
      },
      view: function (name) {
        if (disposed) return;
        var v = viewOf(name);
        tweenTo(v.az, v.el, farFor(v.az, v.el), 560);
      },
      zoom: function (dir) {
        if (disposed) return;
        var s = tween ? tween.b : getSph(), r = clampR(s.r * Math.pow(0.8, dir > 0 ? 1 : -1), s.az, s.el);
        tweenTo(s.az, s.el, r, 240);
      },
      resize: function () {
        if (disposed) return;
        if (measure()) { if (raf) { win.cancelAnimationFrame(raf); raf = 0; } draw(); invalidate(); }
      },
      snapshot: function (w, h, vName) {
        if (disposed) return null;
        return withCamera(w, h, vName, function (W, H) {
          renderer.render(scene, camera);
          var out = doc.createElement("canvas"), ctx;
          out.width = W; out.height = H; ctx = out.getContext("2d");
          ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H); ctx.drawImage(canvas, 0, 0, W, H);
          return out;
        });
      },
      // extras (not in the contract): where a print point lands, for tests and for the proof
      probe: function (area, xIn, yIn) { return disposed ? null : probe(area, +xIn, +yIn); },
      project: function (pt, w, h, vName) {
        if (disposed || !pt) return null;
        return withCamera(w, h, vName, function (W, H) {
          var v = new THREE.Vector3(pt.x, pt.y, pt.z).project(camera);
          return [(v.x + 1) / 2 * W, (1 - v.y) / 2 * H, v.z];
        });
      },
      info: function () { return G ? { size: state.size, keys: G.keys, box: G.box.slice() } : null; },
      stats: function () {
        if (disposed) return null;
        var m = renderer.info.memory, r = renderer.info.render, p = {}, k;
        for (k in prints) if (prints.hasOwnProperty(k)) p[k] = prints[k].rect ? prints[k].rect.slice() : null;
        return { geometries: m.geometries, textures: m.textures, frame: r.frame, calls: r.calls, triangles: r.triangles,
          size: state.size, color: state.color, heather: state.heather, prints: p };
      },
      dispose: function () {
        if (disposed) return;
        disposed = true;
        if (raf) win.cancelAnimationFrame(raf);
        if (backupT) win.clearTimeout(backupT);
        raf = 0; backupT = 0; tween = null;
        try { if (ro) ro.disconnect(); } catch (e) { }
        win.removeEventListener("resize", onWinResize);
        doc.removeEventListener("visibilitychange", onVis);
        canvas.removeEventListener("webglcontextlost", onLost, false);
        canvas.removeEventListener("webglcontextrestored", onRestored, false);
        controls.removeEventListener("change", onControlsChange);
        controls.removeEventListener("start", onControlsStart);
        controls.removeEventListener("end", onControlsEnd);
        controls.dispose();
        var list = [groundMat, groundTex, knitTex, ribTex, fabTex, blankTex], k, s;
        for (s in geos) if (geos.hasOwnProperty(s)) for (k in geos[s]) if (geos[s].hasOwnProperty(k)) list.push(geos[s][k]);
        for (k in MATS) if (MATS.hasOwnProperty(k)) list.push(MATS[k]);
        for (k in prints) if (prints.hasOwnProperty(k)) { list.push(prints[k].tex); prints[k].src = prints[k].tex = null; prints[k].cv.width = 1; }
        if (ground) list.push(ground.geometry);
        for (k = 0; k < list.length; k++) try { if (list[k]) list[k].dispose(); } catch (e3) { }
        try { renderer.dispose(); renderer.forceContextLoss(); } catch (e4) { }
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    };
    function onWinResize() { api.resize(); }
    function onLost(e) { e.preventDefault(); }
    function onRestored() { invalidate(); }
    function onVis() { if (!doc.hidden) invalidate(); }
    canvas.addEventListener("webglcontextlost", onLost, false);
    canvas.addEventListener("webglcontextrestored", onRestored, false);
    doc.addEventListener("visibilitychange", onVis);
    var ro = null;
    if (win.ResizeObserver) { ro = new win.ResizeObserver(function () { api.resize(); }); ro.observe(host); }
    win.addEventListener("resize", onWinResize);

    api.set({ size: opts.size || "adult", color: opts.color || "white" });
    if (!measure()) controls.update();
    invalidate();
    canvas.setAttribute("data-ardor-dtf3d", "ready");
    return api;
  }

  root.ArdorDtf3D = { create: create, version: "1.0.0", colors: COLORS, presets: PRESETS, _shirt: shirt };
})(typeof window !== "undefined" ? window : this);
